export const ConfigStore = {
  configs: [
    {
      key: 'taiwan-student',
      value: {
        notice: '台湾地区高中毕业生入学申请',
        title: '上海师范大学2021年台湾地区高中毕业生入学申请表',
        details: [
          ['本表为 2021 年招收台湾高中毕业生所用。'],
          [
            '本表请用电脑填写后打印（简体或繁体字皆可），另需手写签名“申请人声明”。'
          ],
          ['请如实填写本表，否则将取消申请和录取资格。']
        ]
      }
    }
  ] as { key: string; value: any }[]
}
